import { render, staticRenderFns } from "./WebsiteColor.vue?vue&type=template&id=58b7093f&lang=pug"
import script from "./WebsiteColor.vue?vue&type=script&lang=js"
export * from "./WebsiteColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports